import { Flex, Message } from '@lucidhq/lucidium';

import { Layout } from '@/components';

export const NotFound = () => (
  <Layout size="medium">
    <Flex
      lss={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '500px',
        gap: 20,
      }}
    >
      <Message
        message="Page Not Found"
        description="We couldn't find that page. Is it possible that you found a bad link or
        mistyped the address?"
      />
    </Flex>
  </Layout>
);
